module.exports = __webpack_public_path__ + "static/assets/95f749c292f2e5064d944a2a1dc77692.svg";